import React from 'react';
import {useNavigate} from "react-router-dom";

const TransferLearnerJoz = ({tableData, setTableData, submitDataHandler}) => {

  const navigateTo = useNavigate();
  const checkedHandler = (value, index) => {
    tableData?.forEach((item, row) => {
      if (row === index) {
        if (value === false) {
          item.checked = "2";
        } else {
          item.checked = "1";
        }
      }
    })
    setTableData([...tableData])
  }

  try {
    return (
      <div className="transferLearnerJoz">

        <ul className={"table-learner-joz"}>
          <li className={"header-small"}>
            <h6 style={{width: '30%'}}>کد زبان آموز</h6>
            <h6 style={{width: '60%'}}>مشخصه زبان آموز</h6>
            <h6 style={{width: '10%'}}>عملیات</h6>
          </li>
          {tableData?.length > 0 ? tableData.map((item, index) =>
            <li key={"row" + index}>
              <h6 style={{width: '30%'}}>{item?.studentId}</h6>
              <h6 style={{width: '60%'}}>{item?.studentName}</h6>
              <h6 style={{width: '10%'}}>
                <label className="checkbox-container">
                  <input type="checkbox" checked={item?.checked === "1"}
                         onChange={(e) => checkedHandler(e.target.checked, index)}/>
                  <span className="checkmark"></span>
                </label>
              </h6>
            </li>
          ) : <li className={"no-user"}>دانش آموزی در کلاس مبدا نیست</li>}
        </ul>

        <div className={"row-button"}>
          <button className={"cansel-button"} onClick={() => navigateTo("/Dashboard")}>انصراف</button>
          <button onClick={submitDataHandler}>انتقال</button>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default TransferLearnerJoz;